import template from './modalCalendarGrid.html';
import controller from './modalCalendarGrid.controller';
import './modalCalendarGrid.scss';

let modalCalendarGridComponent = {
  restrict: 'E',
  bindings: {
    userId: '<',
    userInceptionId: '<',
    onDismiss: '&',
    isInception: '<'
  },
  template,
  controller
};

export default modalCalendarGridComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalCalendarGrid/modalCalendarGrid.component.js